export default __webpack_public_path__ + "static/media/dark-chart.e7a0453d.png";